import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonService } from '../../../services/common';
import { SalesService } from '../../sales/sales.service';
import { Subject, takeUntil } from 'rxjs';
import { ChartsConfig } from '../../../common-components/common-chart/chart-option-modal';

@Component({
  selector: 'app-sales-dashboard',
  templateUrl: './sales-dashboard.component.html',
  styleUrl: './sales-dashboard.component.scss'
})
export class SalesDashboardComponent implements OnInit, OnChanges {
  saleReportRequest: any
  saleList: any;

  //#region TILES AND UNIT CATEGORY GRAPHS VARIABLES  
  // Total Sum for Tile Data & Unit Category wise Totals for Graphs Variables
  totalUnitsSum: any = 0;
  totalUnitBookedSum: any = 0
  totalUnitAlottedSum: any = 0
  totalUnitSold: any = 0

  totalAmountSoldUnit: any = 0
  totalAmountReceived: any = 0
  totalBalancedAmountSum: any = 0

  //these are unit category wise total and sold unit to show unit category wise sale graphs 
  unitCategories: any[] = []
  categoryWiseTotalUnits: any[] = []
  categoryWiseSoldUnits: any[] = []
  unitCategoryCharOptions: any = {}
  //#endregion

  //#region DataSeries
  monthWieWeeklySaleChartData: any = {}
  arrayData: any
  //#endregion


  chartOptions = {}

  constructor(public commonService: CommonService, public salesService: SalesService) { }
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.saleReportRequest = {
      "ReportFrequency": 'daily',
    }
    this.getSaleData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getSaleData();
  }

  /**
   * Data Data for Tiles
   */
  getSaleData() {
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {
        //reset allvalues/sum initieated earlier
        this.resetAllTotals();

        this.getSaleTrendDataSeries(selectedProject?.id)


        //project ids has tp go in array as for admin view we may need report for all in single view
        this.saleReportRequest.projectId = [selectedProject?.id]

        this.salesService.getUnitCategoryWiseSale(this.saleReportRequest).subscribe(res => {
          if (res != null && res?.result.length > 0) {
            this.resetAllTotals()
            this.saleList = res?.result.map((cat: any) => {
              this.totalUnitsSum = this.totalUnitsSum + ((cat?.totalUnits != null && cat?.totalUnits != undefined) ? cat?.totalUnits : 0);
              this.totalUnitBookedSum = this.totalUnitBookedSum + ((cat?.unitsBooked != null && cat?.unitsBooked != undefined) ? cat?.unitsBooked : 0);
              this.totalUnitAlottedSum = this.totalUnitAlottedSum + ((cat?.unitsAllotted != null && cat?.unitsAllotted != undefined) ? cat?.unitsAllotted : 0);
              this.totalAmountSoldUnit = this.totalAmountSoldUnit + ((cat?.amountOfSoldUnits != null && cat?.amountOfSoldUnits != undefined) ? cat?.amountOfSoldUnits : 0);
              this.totalAmountReceived = this.totalAmountReceived + ((cat?.amountReceived != null && cat?.amountReceived != undefined) ? cat?.amountReceived : 0);
              this.totalBalancedAmountSum = this.totalBalancedAmountSum + ((cat?.balancedAmount != null && cat?.balancedAmount != undefined) ? cat?.balancedAmount : 0);

              cat.balancedAmount = ((cat?.amountOfSoldUnits != null ? cat?.amountOfSoldUnits : 0) -
                (cat?.amountReceived != null ? cat?.amountReceived : 0))?.toLocaleString('en-IN');


              cat.amountOfSoldUnits = cat?.amountOfSoldUnits.toLocaleString('en-IN')
              cat.amountReceived = cat?.amountReceived?.toLocaleString('en-IN');

              //push category total in arrays for category total
              this.categoryWiseTotalUnits.push(cat?.totalUnits)
              this.categoryWiseSoldUnits.push(cat?.unitsBooked + cat?.unitsAllotted)
              return cat;
            })

            this.totalUnitSold = this.totalUnitBookedSum + this.totalUnitAlottedSum

            this.totalBalancedAmountSum = this.totalAmountSoldUnit - this.totalAmountReceived
            this.totalBalancedAmountSum = this.totalBalancedAmountSum?.toLocaleString('en-IN');

            this.totalAmountSoldUnit = this.totalAmountSoldUnit?.toLocaleString('en-IN');
            this.totalAmountReceived = this.totalAmountReceived?.toLocaleString('en-IN');


            //Get Unitcategories wise sale data
            //First get all distincy Unit categories
            this.unitCategories = this.commonService.getDistinctKeyValueFromArray(res?.result, 'unitCategoryCode')
            this.prepareUnitCategoryWiseSaleGraph();
          }// end of if res?.result condition
        }) //end of api request
      }); //end of project change subscription
  }

  /**
   * Get and set data for Dynamic Monthly Sale/weekly/daily sale
   */
  getSaleTrendDataSeries(projectId: any) {
    //prepare Request Object
    var wekklySalerequest = {
      userId: this.commonService.getValueFromLocalStorage('userId'),
      projectId: [projectId]
    }

    //Get Sale Data
    this.salesService.getMonthWiseWeeklySale(wekklySalerequest).subscribe(res => {
      if (res && res?.result.length > 0)
        this.prepareMonthWiseWeeklySaleData(res?.result[0]?.monthlyData)
    })
  }

  prepareMonthWiseWeeklySaleData(saleData: any) {
    this.monthWieWeeklySaleChartData = {
      primaryCharContainerId: "yearly-chart",
      secondaryCharContainerId: "quarter-chart",
      primaryChartSeriesData: saleData
    }
  }

  /**
   * Prepare chart options for Unit Category wise graph from data alreway got for tiles
   */
  prepareUnitCategoryWiseSaleGraph() {
    this.unitCategoryCharOptions = {
      series: [
        {
          name: "Total Units",
          data: this.categoryWiseTotalUnits
        },
        {
          name: "Sold Units",
          data: this.categoryWiseSoldUnits
        }
      ],
      chart: {
        type: "bar",
        height: 300,
      },
      title: {
        text: "Unit Category Wise Sale",
        style: {
          fontSize: ChartsConfig.TitleFontSize
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        show: true,
        width: 4,
        colors: ["transparent"]
      },
      xaxis: {
        categories: this.unitCategories
      },
      yaxis: {
        title: {
          text: "# of Units"
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val + " Units";
          }
        }
      }
    };
  }

  /**
   * Reset Tile data values and other sale data
   */
  resetAllTotals() {
    this.totalUnitsSum = 0
    this.totalUnitBookedSum = 0
    this.totalUnitAlottedSum = 0
    this.totalAmountSoldUnit = 0
    this.totalAmountReceived = 0
    this.totalBalancedAmountSum = 0
    this.totalUnitSold = 0

    this.unitCategories = []
    this.categoryWiseTotalUnits = []
    this.categoryWiseSoldUnits = []
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
